import { Map, Set } from 'immutable';
import { initialTimeslotSelection } from "./TimeslotInput/TimeslotInputState";
import { moment } from "../../../../../custom_utils/moment";
import { validateField } from "./LocationOptionFormValidation";
export const minimumRentalDate = moment().add(1, 'weeks').toDate();
const initialLocationOptionData = {
    firstName: "",
    infix: "",
    lastName: "",
    companyName: "",
    email: "",
    phoneNumber: "",
    date: minimumRentalDate,
    seatplanId: undefined,
    participants: 0,
    timeslots: initialTimeslotSelection,
    means: Map(),
    note: ""
};
const testLocationOptionData = ()=>({
        firstName: "Andra",
        infix: "ver",
        lastName: "Aart",
        companyName: "Hoppinger",
        email: `andraveraart+dnb-${Date.now().toString().slice(6)}@hoppinger.com`,
        phoneNumber: "0632165498",
        date: moment().add(5, 'years').toDate(),
        seatplanId: (()=>{
            console.error("WARNING: TEST DATA BEING USED FOR FORM");
            return undefined;
        })(),
        participants: 12,
        timeslots: {
            ...initialTimeslotSelection,
            evening: true
        },
        means: Map(),
        note: "TEST DOOR HOPPINGER - " + new Date().toISOString()
    });
export const initialState = {
    data: initialLocationOptionData,
    visited: Set(),
    validationMessages: Map(),
    message: undefined,
    expandedMeansCategories: Set(),
    submitting: false,
    monthlyAvailabilities: Map()
};
export const setMeans = (means)=>(id, amount)=>amount <= 0 ? means.remove(id) : means.set(id, amount);
export const allFields = Set(Object.keys(initialLocationOptionData));
export const setVisited = (setState)=>(field)=>setState((s)=>({
                ...s,
                visited: s.visited.add(field)
            }));
export const validateFormData = (setState, validatorProps)=>(visited)=>setState((prevState)=>{
            const validationMessages = validateFields(visited, prevState.data, validatorProps);
            return {
                ...prevState,
                validationMessages,
                visited
            };
        });
export const validateFields = (fields, data, validatorProps)=>fields.reduce((messages, field)=>{
        const result = validateField(validatorProps)(field)(data[field]);
        return result.status == 'invalid' ? messages.set(field, result.message) : messages;
    }, Map());
export const setFieldOnState = (setState)=>(field)=>(value, callback)=>setState((s)=>({
                    ...s,
                    data: {
                        ...s.data,
                        [field]: value
                    }
                }), ()=>callback && callback());
